export const calculateLicensePoints = (premiumLicenses: number): number => {
  const POINTS_PER_LICENSE = 399; // Mise à jour à 399 points par licence
  return premiumLicenses * POINTS_PER_LICENSE;
};

export const calculatePointsValue = (points: number): number => {
  // 100 points = 5€
  return (points / 100) * 5;
};

export const formatCurrency = (amount: number): string => {
  return new Intl.NumberFormat('fr-FR', {
    style: 'currency',
    currency: 'EUR',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  }).format(amount);
};

export const syncLicensePointsWithAuthorized = async (
  userId: string, 
  authorizedLicenses: number
): Promise<number> => {
  const points = calculateLicensePoints(authorizedLicenses);
  return points;
};